import exp from 'constants';
import styled from 'styled-components';

export const ProductArea = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    border: 1px solid
        ${({ theme }) =>
            theme.theme === 'dark' ? theme.colors.antdBorder : '#f0f0f0'};
    padding: 16px;
    border-radius: 8px;
    box-sizing: border-box;
    position: relative;
`;

export const ProductFigureArea = styled.div`
    width: 124px;
    height: 124px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ProductTitle = styled.h1`
    font-size: 16px;
    color: #30374a;
    margin: 0;
    font-weight: 500;
`;

export const ImageWrapper = styled.div`
    width: 100%;
    height: 100%;
    padding: 8px;
    box-sizing: border-box;
`;

export const ProductInfoArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ProductInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const BarCodeArea = styled.div`
    display: flex;
    align-items: center;
    color: #b0b0b0;
    font-size: 13px;
`;

export const CategoryProduct = styled.div`
    background: #e5f0ff;
    color: #30374a;
    display: flex;
    justify-content: center;
    border-radius: 4px;
    height: 22px;
    align-items: center;
    padding: 0 8px;
    width: fit-content;
`;

export const PlanogramContainer = styled.div`
    margin-top: 15px;
`;

export const PlanogramTitle = styled.span`
    font-size: 13px;
    color: #b0b0b0;
    font-weight: 500;
`;

export const RemoveProductButton = styled.button`
    position: absolute;
    top: 50%;
    right: 16px;
    background: transparent;
    border: none;
    transform: translateY(-50%);
    cursor: pointer;
`;
